import { render, staticRenderFns } from "./ContractListItem.vue?vue&type=template&id=15de5194&scoped=true&"
import script from "./ContractListItem.vue?vue&type=script&lang=ts&"
export * from "./ContractListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15de5194",
  null
  
)

export default component.exports